export function downloadFromBlob(blob, fileName) {
  try {
    const link = document.createElement("a");
    link.href = blob;
    link.download = fileName;
    link.setAttribute("target", "_blank");
    link.click();
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
}

export function urlInfo(name) {
  let result = "";
  if (name?.length) {
    result = name.toLowerCase().split(" ").join("-").toLocaleLowerCase();
  }
  return result;
}

export const handleLinkClick = (e, url, router) => {
  if (url) {
    const isAbsoluteUrl = /^(http|https):\/\//.test(url);
    if (isAbsoluteUrl) {
      // Reload the page for absolute URLs
      e.preventDefault();
      window.location.href = url;
    } else {
      // Use client-side routing for relative paths
      e.preventDefault();
      router.push(url);
    }
  }
};

export const capitalizeText = (text) => {
  const cleanedText = text.replace(/[\/-]/g, " ").toLowerCase();

  return cleanedText
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" ");
};
